import { message } from 'antd';
import { client } from '../../../actions';
import uri from '../constants/uri';

const sendRecoverCode = async (login) => {
  try {
    const response = await client.post(
      `${uri}/recover_password_send`,
      {},
      {
        params: {
          login,
        },
      }
    );
    if (response.data.result === 'Error') {
      return false;
    }
    return true;
  } catch (error) {
    console.error(error);
    message.error('Произошла ошибка');
    return false;
  }
};

export default sendRecoverCode;
